import React from "react";
import "./plusIconBlue.css"

const PlusIconBlue = ({onClick, className =''}) =>{


    
return(
    <svg onClick={onClick} className={`cursor ${className} `} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="11.5" cy="12.5" r="10.5" fill="#094C80"/>
        <path d="M7 12.5H16" stroke="white" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.5 8V17" stroke="white" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

)};

export default PlusIconBlue